import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=545531b9&functional=true&"
import script from "./FacebookIcon.vue?vue&type=script&lang=ts&"
export * from "./FacebookIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports